module.exports = __webpack_public_path__ + "bbef67d7d18234db7055f4dfb6e873a2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Header/menu_title.png
 ** module id = 299
 ** module chunks = 0
 **/